import React from 'react'
import Storage from '../../../npo-start-player-web/src/storage/storage'
import FormButton from '../../components/form/form-button/FormButton'
import './app-tab-export.scss'

/**
 * The export tab within the app.
 * 
 * @author Stan Hurks
 */
export default class AppTabExport extends React.Component {

    public render = () => {
        return (
            <div className="app-tab-export">
                <div className="app-tab-export-copy">
                    <FormButton onClick={() => {
                        navigator.clipboard.writeText(this.getCode()).then(() => {
                            console.debug('Copied to clipboard.')
                        }).catch((err) => {
                            console.error('Could not copy to clipboard: ', err)
                        })
                    }}>
                        Copy
                    </FormButton>
                </div>
                <div className="app-tab-export-code">
                    {
                        this.getCode().split('\n').map((line, lineIndex) => (
                            <div className="app-tab-export-code-line" key={lineIndex}>
                                {line.split(/(\t|    )/g).map((tab, tabIndex) => (
                                    <span className="app-tab-export-code-line-tab" key={tabIndex}>
                                        {
                                            tab === ''
                                                ? <>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                </>
                                                : tab
                                        }
                                    </span>
                                ))}
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }

    /**
     * Get the code
     */
    private getCode = (): string => {
        // Highlighting in vscode can be done with es6-string-javascript
        let code = /*javascript*/`
            import Player from 'npo-start-player-web'
            const container = document.getElementById('[Container ID here]')

            const player = new Player({
                container,
                web: {
                    keys: {
                        player: '[Player key here]',
                        analytics: '[Analytics key here]'
                    }
                }
                theme: {
                    colors: {
                        primary: {r: ${Storage.data.theme.colorPrimary.r}, g: ${Storage.data.theme.colorPrimary.g}, b: ${Storage.data.theme.colorPrimary.b}},
                        secondary: {r: ${Storage.data.theme.colorSecondary.r}, g: ${Storage.data.theme.colorSecondary.g}, b: ${Storage.data.theme.colorSecondary.b}},
                    },
                    logo: ${Storage.data.theme.hasLogo ? /*javascript*/`{
                        src: ${'"'}${Storage.data.theme.logoSrc}${'"'},
                        url: ${'"'}${Storage.data.theme.logoURL}${'"'},
                        fadeOutAtMs: ${Storage.data.theme.logoFadeOutAtMs},
                        fadeOutDurationMs: ${Storage.data.theme.logoFadeOutDurationMs}
                    }` : 'null'},
                    autoHideControls: ${Storage.data.theme.autoHideControls ? 'true': 'false'}
                },
                playback: {
                    autoplay: ${Storage.data.playback.autoplay},
                    volume: ${Storage.data.playback.volume}
                }
            })

            player.load({
                title: ${'"'}${Storage.data.source.title}${'"'},
                description: ${'`'}${Storage.data.source.description}${'`'},
                protocol: ${'"'}${Storage.data.source.protocol}${'"'},
                prid: ${'"'}${Storage.data.source.prid}${'"'},
                thumbnailTrack: {
                    url: ${'"'}${Storage.data.source.thumbnailTrackURL}${'"'}
                },
                poster: ${'"'}${Storage.data.source.poster}${'"'},
                subtitleTracks: [
                    {
                        id: "nl",
                        label: "Nederlands",
                        lang: "nl-nl",
                        kind: "subtitle",
                        url: ${'"'}${Storage.data.source.subtitleURL}${'"'}
                    }
                ]
            })
        `
        // Replace the extra tabs
        .replace(/\n(\t|    ){3}/g, '\n')
        return code
    }
}